<main *ngIf="form">
    <tarifrechner-common-loading-screen [loading]="isLoading | async" text="Ihre Daten werden an uns übermittelt..."></tarifrechner-common-loading-screen>
    <div class="cyber-zusammenfassung h-spacer-l l-container l-container--m" >
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="l-container h-text-center">
                <h1 class="h-spacer-l">{{currentSeite.seiteDefinition.label}}</h1>
                <div class="h-font-regular h-color-black" *ngIf="currentRate">
                    <p class="h-font-m h-font-medium" style="margin:0">Nettobeitrag</p>
                    <h1 class="h-spacer-s h-font-xxl h-color-pri-dark">
                        {{ currentRate.gesamtJahresNettoBeitrag | currency:'EUR':'symbol-narrow' }}
                        <span class="h-font-m h-font-medium h-color-black">jährlich</span>
                    </h1>
                </div>

                <div class="h-font-regular h-color-black"  *ngIf="currentRate">
                    <span class="h-font-m">
                        Brutto
                        <strong>{{ currentRate.gesamtJahresBruttoBeitrag | currency:'EUR':'symbol-narrow' }}</strong>
                        jährlich
                        <br> <span class="h-font-s">(inkl. 19% Versicherungsteuer)</span>
                    </span>
                </div>

            </div>

            <div class="cyber-zusammenfassung__box l-container l-container--m" style="padding-top: 0.5rem;">
                <h2 class="h-font-l h-font-medium h-color-black">Alle Vorteile auf einen Blick</h2>

                <p class="h-text-left h-font-m h-font-medium h-color-black">
                    <span>
                        <svg class="icon h-color-pri">
                            <use xlink:href="#icon-check"></use>
                        </svg>
                    </span>
                    24/7-Soforthilfe durch zertifizierten IT-Dienstleister
                </p>

                <p class="h-text-left h-font-m h-font-medium h-color-black">
                    <span>
                        <svg class="icon h-color-pri">
                            <use xlink:href="#icon-check"></use>
                        </svg>
                    </span>
                    Fehlbedienung mitversichert
                </p>

                <p class="h-text-left h-font-m h-font-medium h-color-black">
                    <span>
                        <svg class="icon h-color-pri">
                            <use xlink:href="#icon-check"></use>
                        </svg>
                    </span>
                    Sachschäden an Hardware mitversichert
                </p>
            </div>

            <button class="m-button m-button--full h-spacer-l h-spacer-top" type="button" (click)="onSubmit()">
                <span>{{getSubmitButtonText()}}</span>
            </button>



            <h2 class="h-spacer-s h-text-left h-font-l" *ngIf="currentRate">Ihre Bausteine&nbsp;<span class="h-font-s">(Angaben in Netto)</span></h2>

            <div class="h-spacer-l m-overview-table" *ngIf="currentRate">
                <div class="m-overview-table__row">
                    <div class="h-text-left">
                        <span class="h-font-m m-overview-table__item-name">Grundbaustein</span>
                    </div>
                    <div class="h-text-right h-font-m h-color-pri-dark">
                        <span>{{ currentRate.beitraegeFuerBausteine.get('Grundbaustein').gesamtJahresNettoBeitrag | currency:'EUR':'symbol-narrow' }}</span>
                        <span>&nbsp;jährlich</span>
                    </div>
                </div>
                <div class="m-overview-table__row" *ngFor="let baustein of getBausteine() | keyvalue" >
                    <div class="h-text-left">
                        <span class="h-font-m m-overview-table__item-name">{{getBausteinBezeichnungen(baustein.key)}}</span>
                    </div>
                    <div class="h-text-right h-font-m h-color-pri-dark">
                        <span>{{ baustein.value.gesamtJahresNettoBeitrag | currency:'EUR':'symbol-narrow' }}</span>
                        <span>&nbsp;jährlich</span>
                    </div>
                </div>
            </div>

            <h2 class="h-spacer-s h-text-left h-font-l">Ihre Selbstbeteiligung je Versicherungsfall</h2>

            <div class="h-spacer-l cyber-zusammenfassung__list">
                <p class="h-text-left h-font-m h-font-regular h-color-black">Selbstbeteiligung&nbsp;</p>
                <p class="h-text-left h-font-m h-font-medium h-color-pri-dark">{{getOberflaechenElementEintraegeWert('MonetaererSelbstbehalt')}}</p>

                <p class="h-text-left h-font-m h-font-regular h-color-black">Zeitliche Selbstbeteiligung&nbsp;</p>
                <p class="h-text-left h-font-m h-font-medium h-color-pri-dark">{{getOberflaechenElementEintraegeWert('ZeitlicherSelbstbehalt')}}</p>
            </div>

            <h2 class="h-spacer-s h-text-left h-font-l">Ihre persönlichen Daten</h2>

            <div class="h-spacer-l cyber-zusammenfassung__list">
                <p class="h-text-left h-font-m h-font-regular h-color-black">Antragsteller/in</p>
                <p class="h-text-left h-font-m h-font-medium h-color-black">{{getOberflaechenElementWert('Vorname')}}&nbsp;{{getOberflaechenElementWert('Nachname')}}</p>

                <p class="h-text-left h-font-m h-font-regular h-color-black" *ngIf="isFirma()">Firma</p>
                <p class="h-text-left h-font-m h-font-medium h-color-black" *ngIf="isFirma()">{{getOberflaechenElementWert('Firmenname')}}</p>

                <p class="h-text-left h-font-m h-font-regular h-color-black">Telefon</p>
                <p class="h-text-left h-font-m h-font-medium h-color-black">{{getOberflaechenElementWert('Telefon')}}</p>

                <p class="h-text-left h-font-m h-font-regular h-color-black">Adresse</p>
                <p class="h-text-left h-font-m h-font-medium h-color-black">{{getOberflaechenElementWert('Strasse')}}&nbsp;{{getOberflaechenElementWert('Hausnummer')}}<br>{{getOberflaechenElementWert('PLZ')}}&nbsp;{{getOberflaechenElementWert('Ort')}}</p>

                <p class="h-text-left h-font-m h-font-regular h-color-black">E-Mail</p>
                <p class="h-text-left h-font-m h-font-medium h-color-black">{{getOberflaechenElementWert('Email')}}</p>

                <p class="h-text-left h-font-m h-font-regular h-color-black" *ngIf="currentRate">IBAN</p>
                <p class="h-text-left h-font-m h-font-medium h-color-black" *ngIf="currentRate">{{getOberflaechenElementWert('IBAN')}}</p>
            </div>

            <div class="h-spacer-l cyber-zusammenfassung__list" *ngIf="currentRate">
                <p class="h-text-left h-font-m h-font-regular h-color-black">
                    <span>
                        <svg class="icon h-color-pri-dark">
                            <use xlink:href="#icon-calendar"></use>
                        </svg>
                    </span>
                    Versicherungsbeginn
                </p>
                <p class="h-text-left h-font-m h-font-medium h-color-black">{{getVersicherungsbeginn()}}</p>

                <p class="h-text-left h-font-m h-font-regular h-color-black">
                    <span>
                        <svg class="icon h-color-pri-dark">
                            <use xlink:href="#icon-clock"></use>
                        </svg>
                    </span>
                    Laufzeit bis
                </p>
                <p class="h-text-left h-font-m h-font-medium h-color-black">{{getOberflaechenElementWert('Versicherungsablauf')}}</p>

                <p class="h-text-left h-font-m h-font-regular h-color-black">
                    <span>
                        <svg class="icon h-color-pri-dark">
                            <use xlink:href="#icon-euro"></use>
                        </svg>
                    </span>
                    Zahlungsweise
                </p>
                <p class="h-text-left h-font-m h-font-medium h-color-black">jährlich</p>
            </div>

            <button class="m-button m-button--full h-spacer-s" type="button" (click)="onSubmit()">
                <span>{{getSubmitButtonText()}}</span>
            </button>

        </form>
    </div>

    <vhv-footer [show-next]="false" [page-reused]="isPageReused"></vhv-footer>
</main>
